import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=e1474dd4&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=e1474dd4&prod&lang=less"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=e1474dd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1474dd4",
  null
  
)

export default component.exports